@if (dataHasLoaded) {
	<div class="container" class="fx-layout-column fx-gap-8">
		<ft-form-setup></ft-form-setup>
	</div>
}
